import React, {useEffect} from 'react';
import track from 'utils/track';
import SalesIndex from '../join';

export default function () {
  useEffect(
    () =>
      track('Product Viewed', {
        product_id: 'SC-PPP',
        sku: 'SC-PPP',
        name: 'Plant-Powered Playbook',
        variant: 'ppp-special',
        value: 97,
        currency: 'usd'
      }),
    []
  );
  return (
    <SalesIndex
      noFixedVideo
      noExitIntent
      ctaNoTimer
      ctaOverride="joinSales"
      variant="ad"
      bucketOverride="health"
      pageTitle="Food Revolution Network’s Plant-Powered Playbook"
      pageDescription="Make a difference with the food you eat"
      ogImage="https://cdn.foodrevolution.org/ppp/og/ppp-opengraph-sales-Health-motivated-1200x1200-v20221025.jpg"
      shareUrl="https://plantplaybook.foodrevolution.org/a/join-health/"
      facebookDescription="Want to make a difference in climate change, be kind to animals, and know you’re doing the best thing for your health — while eating delicious food? The Plant-Powered Playbook shows you how. Learn more here:"
      twitterDescription="Want to make a difference in climate change, be kind to animals, and know you’re doing the best thing for your health — while eating delicious food? The Plant-Powered Playbook shows you how. Learn more here:"
      twitterImg="https://cdn.foodrevolution.org/ppp/og/ppp-opengraph-sales-Health-motivated-1200x675-20221025.jpg"
      pinterestDescription="Want to make a difference in climate change, be kind to animals, and know you’re doing the best thing for your health — while eating delicious food? The Plant-Powered Playbook shows you how. Learn more here:"
      pinterestImage="https://cdn.foodrevolution.org/ppp/og/ppp-opengraph-sales-Health-motivated-1000x1500-20221025.jpg"
    />
  );
}
